import React from "react";
import DataTable from "../DataTable/DataTable"


class ReservationDetails extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    // console.log("this.props.reservation_details_data_table_path", this.props.reservation_details_data_table_path);
    // console.log("time_format", this.props.time_format);
    // console.log("date_format", this.props.date_format);
    return(

      <div className="panel panel-default">
        <div className="panel-body">
          <h3 className="panel-heading-text">{I18n.t("rooms")}</h3>
          <DataTable
            endpoint={this.props.reservation_details_data_table_path}
            date_format={this.props.date_format}
            time_format={this.props.time_format}
            reservation_segments={true}
            tab_data_table={true}
            currency_unit={I18n.t('number.currency.format.unit')}
            delimiter={I18n.t('number.currency.format.delimiter')}
            separator={I18n.t('number.currency.format.separator')} />
        </div>
      </div>
    )

  }


}

export default ReservationDetails
